<div class="cartridges">
  <ng-container
    *ngFor="
      let cartridge of cartridges;
      let o = odd;
      let e = even;
      let i = index
    "
  >
    <div
      class="cartridge flex-col-start"
      [ngClass]="'column-count-' + columnCount"
      tabindex="1"
      [routerLink]="['/cartridge/catalog/' + cartridge.id] + '/detail'"
    >
      <h2 class="flex-row-centered">
        <markant-icon
          *ngIf="cartridge.icon"
          icon="{{ cartridge.icon }}"
          class="headline-icon"
        ></markant-icon>
        <span>{{ cartridge.name }}</span>
      </h2>
      <p class="description" [innerHTML]="cartridge.description"></p>
    </div>
    <ng-container
      *ngIf="i === cartridges.length - 1 && getGapFillCondition(o, e)"
    >
      <div
        class="cartridge hidden-div"
        [ngClass]="'column-count-' + columnCount"
      ></div>
    </ng-container>
  </ng-container>
</div>
